import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { IconButton } from "@mui/material";

const GpayInfo = ({}) => {
    const [show, setShow] = useState(false);
    const [isIndia, setIsIndia] = useState(false);

    const getCountry = async () => {
        await axios
            .get("/api/location")
            .then((response) => {
                console.log("🚀 ~ country:", response.data);

                if (response.data.country_code === "IN") {
                    setIsIndia(true);
                } else {
                    setIsIndia(false);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    useEffect(() => {
        if (show) {
            getCountry();
        }
    }, [show]);

    return (
        <>
            <div
                css={css`
                    width: 100%;
                    text-align: center;
                    font-weight: 400;
                    font-size: 16px;
                    padding: 2px;
                    margin-bottom: 20px;
                `}
            >
                <strong>
                    No worries&mdash;please continue with card payment below.
                </strong>{" "}
                <p>
                    <a
                        className="text-blue"
                        onClick={(e) => {
                            e.preventDefault();
                            setShow(!show);
                        }}
                    >
                        Learn how to set up or fix Google Pay
                    </a>{" "}
                    <IconButton onClick={() => setShow(!show)} size="small">
                        <i className="fa-regular fa-circle-info"></i>
                    </IconButton>
                </p>
            </div>
            {show ? (
                isIndia ? (
                    <React.Fragment>
                        <div
                            className="gpay-india-fallback"
                            css={css`
                                padding: 1em;
                                background-color: #fff3cd;
                                border-left: 4px solid #ffc107;
                                font-family: sans-serif;
                                font-size: 15px;
                                line-height: 1.6;
                            `}
                        >
                            <strong>
                                Google Pay not available for this device or
                                setup.
                            </strong>
                            <br />
                            <br />
                            It looks like you're using Google Pay linked to your
                            bank account via UPI — a common setup in India.
                            While UPI works beautifully for QR payments and
                            transfers, it unfortunately isn’t supported for
                            online card-based checkout systems like this one.
                            <br />
                            <br />
                            To use Google Pay here, please:
                            <ul
                                css={css`
                                    margin: 0.5em 0 0 1em;
                                    padding-left: 1em;
                                `}
                            >
                                <li>
                                    Make sure you're using{" "}
                                    <strong>
                                        Google Chrome (not Incognito)
                                    </strong>
                                </li>
                                <li>
                                    Be signed into your{" "}
                                    <strong>Google account</strong> on this
                                    browser
                                </li>
                                <li>
                                    Have a valid{" "}
                                    <strong>credit or debit card</strong> added
                                    to your Google Pay wallet
                                </li>
                            </ul>
                            <br />
                            If you prefer, you can continue securely with
                            another payment method below.
                        </div>

                        <div className="gpay-missing-card-warning">
                            <strong>
                                Google Pay not available on this device or
                                setup.
                            </strong>
                            <br />
                            If you are using Google Pay, please ensure your
                            wallet has an active debit or credit card linked to
                            it.
                            <br />
                            <br />
                            👉{" "}
                            <a
                                href="https://pay.google.com/gp/w/u/0/home/addcard"
                                target="_blank"
                            >
                                Click here to add a card to your Google Wallet
                            </a>
                        </div>
                    </React.Fragment>
                ) : (
                    <div
                        className="gpay-troubleshoot-message"
                        css={css`
                            padding: 1em;
                            background-color: #f8f9fa;
                            border-left: 4px solid #4285f4;
                            font-family: sans-serif;
                            font-size: 15px;
                            line-height: 1.5;
                        `}
                    >
                        <strong>
                            Google Pay was not detected on this device or
                            browser.
                        </strong>
                        <br />
                        <br />
                        If you have a Google Pay wallet set up, please ensure
                        the following:
                        <ul
                            css={css`
                                margin: 0.5em 0 0 1em;
                                padding-left: 1em;
                            `}
                        >
                            <li>
                                You are{" "}
                                <strong>logged into your Google account</strong>{" "}
                                on this browser (Chrome recommended)
                            </li>
                            <li>
                                Your Google Pay wallet has a{" "}
                                <strong>valid payment method</strong> added
                            </li>
                            <li>
                                You are not using{" "}
                                <strong>Incognito mode</strong> or a browser
                                that blocks third-party cookies
                            </li>
                            <li>
                                You are not using Safari on iPhone (Google Pay
                                is not supported there)
                            </li>
                        </ul>
                        <br />
                        For the best experience, try using the{" "}
                        <strong>
                            Chrome browser on an Android or desktop device
                        </strong>{" "}
                        signed into your Google account.
                        <br />
                        <br />
                        If the issue persists, you can still complete your
                        payment using another secure method below.
                    </div>
                )
            ) : null}
        </>
    );
};

export default GpayInfo;
